import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import appConfig from '@nerdwallet/app-config';
// Exported for testing
export var API_KEY_DATA_ATTRIBUTE = 'data-nerdwallet-google-maps-api-key';
export var useGoogleMapsPlacesApi = function useGoogleMapsPlacesApi(options) {
  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      placesApi = _React$useState2[0],
      setPlacesApi = _React$useState2[1];

  var apiKey = (options === null || options === void 0 ? void 0 : options.apiKey) || appConfig.GOOGLE_MAPS_API_KEY;
  React.useEffect(function () {
    var _window, _window$google, _window$google$maps;

    // If the API was already loaded on this page, let's use it
    if ((_window = window) !== null && _window !== void 0 && (_window$google = _window.google) !== null && _window$google !== void 0 && (_window$google$maps = _window$google.maps) !== null && _window$google$maps !== void 0 && _window$google$maps.places) {
      setPlacesApi(window.google.maps.places);
      return function () {};
    }

    var onLoad = function onLoad() {
      setPlacesApi(window.google.maps.places);
    }; // Let's check if something else already added the script tag


    var googleMapsApiScripts = Array.from(document.querySelectorAll("script[".concat(API_KEY_DATA_ATTRIBUTE, "]"))); // Safety check: who knows what Google Maps will do if you try to load it
    // multiple times on one page with different API keys. If we detect that
    // the script was already loaded with a different API key, warn about that.

    googleMapsApiScripts.forEach(function (script) {
      var scriptApiKey = script.getAttribute(API_KEY_DATA_ATTRIBUTE);

      if (scriptApiKey !== apiKey) {
        // eslint-disable-next-line no-console
        console.warn("Found existing Google Maps API script with API key ".concat(scriptApiKey, "; are you trying to load the API twice?"));
      }
    }); // Check for an existing script; if it's there, wait for it to load and
    // then grab the API off of `window`.

    var existingScript = googleMapsApiScripts.find(function (script) {
      return script.getAttribute(API_KEY_DATA_ATTRIBUTE) === apiKey;
    });

    if (existingScript) {
      existingScript.addEventListener('load', onLoad);
      return function () {
        existingScript.removeEventListener('load', onLoad);
      };
    } // If we get here, we need to add a `<script>` tag. Let's do that.


    var script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?libraries=places&key=".concat(apiKey);
    script.async = true;
    script.setAttribute(API_KEY_DATA_ATTRIBUTE, apiKey);
    document.body.appendChild(script);
    script.addEventListener('load', onLoad); // Clean up event listener once it's no longer needed

    return function () {
      script.removeEventListener('load', onLoad);
    };
  }, [apiKey]);
  return placesApi;
};